export function PinSkeleton() {
  const heights = ['h-48', 'h-64', 'h-72', 'h-56', 'h-80', 'h-52'];
  const h = heights[Math.floor(Math.random() * heights.length)];

  return (
    <div className="masonry-item">
      <div className={`skeleton ${h} rounded-2xl`} />
      <div className="p-3">
        <div className="skeleton h-4 w-3/4 rounded-lg mb-2" />
        <div className="skeleton h-3 w-1/2 rounded-lg" />
      </div>
    </div>
  );
}
